









































































































































































































































import DatePicker from '../common/DatePicker.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';

import {
  FormFieldTypeEnum,
  IFormFieldData,
  IEmployeeFormFieldOptionSubmissionData,
  IEmployeeFormFieldSubmissionData,
  IFormSectionData,
  IFormSectionFieldData,
  IEmployeeFormSectionSubmissionData,
  IEmployeeFormSectionSubmissionFieldErrorData,
  IFormTemplateData,
  ConstraintActionEnum,
  EmployeeFormFieldSubmission,
  IFormFieldOptionData
} from '@/models';

import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import { convertDataURlToFile } from '@/utils/helpers';
import Vue, { PropType } from 'vue';

export interface IFieldAttributes {
  disabled: boolean;
  required: boolean;
}

export default mixins(auth).extend({
  components: {
    DatePicker,
    DragDropFileInput
  },

  props: {
    fieldError: {
      type: Array as PropType<IEmployeeFormSectionSubmissionFieldErrorData[]>
    },
    formTemplate: {
      type: Object as PropType<IFormTemplateData>
    },
    answers: {
      type: Array as PropType<IEmployeeFormSectionSubmissionData[]>
    },
    sectionIndex: Number,
    section: Object as PropType<IFormSectionData>
  },

  data() {
    return {
      FormFieldTypeEnum,
      ConstraintActionEnum
    };
  },

  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.mobile;
    }
  },

  methods: {
    clearAllErrors(): void {
      this.$emit('clearAllErrors');
    },

    genFormFieldProperties(
      sectionField: IFormSectionFieldData,
      fieldIndex = -1
    ): IFieldAttributes {
      let actionAttributes = {
        disabled: sectionField.disabled,
        required: sectionField.required
      };

      if (sectionField.constraints.length > 0) {
        //goest through list of constraints
        sectionField.constraints.forEach(constraint => {
          //find if all constraint’s target option is selected
          const constraintConditionsMet = constraint.conditions.every(
            condition => {
              //find option in answer list

              let index = 0;
              let constraintSubmissionFIeld:
                | IEmployeeFormFieldSubmissionData
                | undefined;

              while (
                !constraintSubmissionFIeld &&
                index < this.answers.length
              ) {
                const answer = this.answers[index];

                constraintSubmissionFIeld = answer.fields.find(field => {
                  if (typeof field.field == 'number') {
                    return field.field == condition.form_section_field;
                  } else {
                    return (
                      (field.field as IFormSectionFieldData).id ==
                      condition.form_section_field
                    );
                  }
                });

                index++;
              }

              const targetOption = (constraintSubmissionFIeld!
                .option_submissions as IEmployeeFormFieldOptionSubmissionData[]).find(
                (option: IEmployeeFormFieldOptionSubmissionData) => {
                  if (typeof option == 'number') {
                    return option == condition.field_option;
                  } else {
                    return option
                      ? option.option == condition.field_option
                      : false;
                  }
                }
              );

              if (targetOption) {
                return true;
              }
            }
          );

          if (constraintConditionsMet) {
            switch (constraint.action) {
              case ConstraintActionEnum.Required:
                actionAttributes = {
                  disabled: false,
                  required: true
                };
                break;

              case ConstraintActionEnum.Optional:
                actionAttributes = {
                  disabled: false,
                  required: false
                };
                break;

              case ConstraintActionEnum.Disabled:
                actionAttributes = {
                  disabled: true,
                  required: false
                };
                break;

              default:
                break;
            }
          }
        });
      }

      const sectionFieldAnswer = this.answers[this.sectionIndex].fields[
        fieldIndex
      ];

      //checks if the target field has been answered and is set to disabled
      this.updateDisabledFieldAnswer(
        actionAttributes.disabled,
        sectionFieldAnswer,
        fieldIndex
      );

      return actionAttributes;
    },

    updateDisabledFieldAnswer(
      isDisabled: boolean,
      sectionFieldAnswer: IEmployeeFormFieldSubmissionData,
      fieldIndex = -1
    ) {
      if (
        isDisabled &&
        fieldIndex != -1 &&
        (sectionFieldAnswer.value ||
          sectionFieldAnswer.option_submissions.length > 0)
      ) {
        //clears submission annswer when disabled
        const submission = new EmployeeFormFieldSubmission({
          field: sectionFieldAnswer.field,
          id: sectionFieldAnswer.id,
          value: '',
          option_submissions: []
        });

        this.answers[this.sectionIndex].fields.splice(
          fieldIndex,
          1,
          submission
        );
      }
    },

    getFieldError(
      fieldError: IEmployeeFormSectionSubmissionFieldErrorData[],
      sectionIndex: number,
      errorFieldIndex: number
    ): string {
      return fieldError[sectionIndex]
        ? fieldError[sectionIndex].errors[errorFieldIndex]
        : '';
    },

    genOptionItems(field: IFormFieldData): IFormFieldOptionData[] {
      return field.options!.map(data => {
        return { ...data, option: data.id };
      });
    },

    genRadioBtnOptionsValue(
      radio: IEmployeeFormFieldSubmissionData,
      submissons: IEmployeeFormFieldOptionSubmissionData[]
    ): IEmployeeFormFieldOptionSubmissionData {
      let value = submissons.find(submisson => submisson.option == radio.id);

      if (!value) {
        value = {
          id: undefined,
          option: radio.id
        } as IEmployeeFormFieldOptionSubmissionData;
      }

      return value;
    },

    genLabel(section_field: IFormSectionFieldData) {
      const attributes = this.genFormFieldProperties(section_field);
      let label = (section_field.field_template as IFormFieldData).label;
      if (attributes.required) {
        label = `${label}*`;
      }
      return label;
    },

    genFileFieldValue(sectionIndex: number, fieldIndex: number) {
      return this.answers[sectionIndex].fields[fieldIndex].value
        ? convertDataURlToFile(
            this.answers[sectionIndex].fields[fieldIndex].value,
            'Attachment'
          )
        : null;
    },

    async addFormAttachments(
      file: File | null,
      sectionIndex: number,
      fieldIndex: number
    ) {
      this.clearAllErrors();
      let base64 = '';

      if (file) {
        base64 = await this.getBase64(file);
      }
      Vue.set(this.answers[sectionIndex].fields[fieldIndex], 'value', base64);
    },

    getBase64(file: File) {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result?.toString() || '');
        reader.onerror = error => reject(error);
      });
    }
  }
});
